var _polygon, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreviewRhombus2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 140,
    viewBox: "0 0 240 140",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "120,10 230,70 120,130 10,70",
    fill: "currentColor",
    stroke: "#808080",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 70,
    r: 20,
    fill: "none",
    stroke: "#808080",
    strokeWidth: 7
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 155,
    cy: 70,
    r: 20,
    fill: "none",
    stroke: "#808080",
    strokeWidth: 7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewRhombus2);
export default __webpack_public_path__ + "static/media/preview-rhombus2.22386e078c152141949b320b3c0d191f.svg";
export { ForwardRef as ReactComponent };